module.exports = __webpack_public_path__ + "img/powered-lliege.09f2c927.png";